import { useEffect, useMemo, useRef, useState } from "preact/hooks";
import type { Theme } from "@fobu/schema";
import { t } from "../lib/i18n";
import { plain } from "../lib/markdown";
import { themeToCssVars } from "../lib/theme";

/** Passwortabfrage vor geschützten Formularen. */
export function PasswordGate({ title, theme, onUnlock }: { title: string; theme?: Theme; onUnlock: (pw: string) => Promise<boolean> }) {
  const [pw, setPw] = useState("");
  const [error, setError] = useState(false);
  const [busy, setBusy] = useState(false);
  const input = useRef<HTMLInputElement>(null);
  const vars = useMemo(() => (theme ? themeToCssVars(theme) : {}), [theme]);
  useEffect(() => {
    document.title = title || t.passwordTitle;
    input.current?.focus();
  }, [title]);
  return (
    <div class="fb-root fb-mode-classic" style={vars}>
      <div class="fb-shell fb-shell--classic">
        <header class="fb-header">
          <h1 class="fb-title">{plain(title)}</h1>
        </header>
        <form
          class="fb-page"
          noValidate
          onSubmit={async (e) => {
            e.preventDefault();
            if (!pw) return;
            setBusy(true);
            const ok = await onUnlock(pw);
            setBusy(false);
            if (!ok) {
              setError(true);
              input.current?.select();
            }
          }}
        >
          <div class="fb-field">
            <label class="fb-label" for="fb-pw">
              {t.passwordLabel}
            </label>
            <p class="fb-desc" id="fb-pw-hint">
              {t.passwordHint}
            </p>
            <input
              ref={input}
              id="fb-pw"
              class="fb-input"
              type="password"
              autoComplete="current-password"
              value={pw}
              aria-invalid={error}
              aria-describedby={error ? "fb-pw-hint fb-pw-err" : "fb-pw-hint"}
              onInput={(e) => (setPw(e.currentTarget.value), setError(false))}
            />
            {error && (
              <p class="fb-error" id="fb-pw-err" role="alert">
                {t.passwordWrong}
              </p>
            )}
          </div>
          <div class="fb-nav">
            <button type="submit" class="fb-btn fb-btn--primary" disabled={busy || !pw}>
              {t.passwordSubmit}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
